import React from 'react';

const ExtensionLabel = ({className, label, children}) => {
	return (
		<span className={`extension-label ml-s${className ? ' ' + className : ''}`}>{label || children}</span>
   );
}

export default ExtensionLabel;